<template>
  <div class="coefficient-alert-modal">
    <PmwAlertModal
      v-model="showAlertModal"
      :preventOverlayClick="true"
      confirmButtonText="Continuar"
      cancelButtonText="Voltar e ajustar"
      cancelButtonColor="blue-100"
      confirmButtonColor="blue-100"
      icon="pmw-alert"
      @alert-modal-cancel="$emit('closeAlert', $event)"
      @alert-modal-confirm="$emit('closeAlert', $event)"
    >
      <template #text>
        <span>
          {{ firstLine }}
          <br />
          {{ mainText }}
          <br />
          <br v-if="lastLine" />
          {{ lastLine }}
        </span>
      </template>
    </PmwAlertModal>
  </div>
</template>

<script>
import PmwAlertModal from '@solucoes/components-lib-tmp/src/components/patterns/PmwAlertModal'
export default {
  name: 'CoefficientModalAlert',

  components: {
    PmwAlertModal
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },

    firstLine: {
      type: String,
      default: ''
    },

    mainText: {
      type: String,
      default: ''
    },

    lastLine: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      showAlertModal: false
    }
  },

  watch: {
    show(newVal) {
      this.showAlertModal = newVal
    }
  }
}
</script>
